import DataTable from "react-data-table-component";
import ButtonIconH from "./ButtonIconH";
import { dashboardSalesTable } from "../js/tableColumns";
import { useEffect, useState } from "react";

export function OpticalSalesContainer({ optical, onLoadMore }) {
  const [summaryData, setSummaryData] = useState([]);
  const [list, setList] = useState(optical.ventas);

  useEffect(() => {
    const inputData = optical.ventas;
    const data = {
      base: inputData.reduce((acc, e) => acc + e.base, 0),
      iva: inputData.reduce((acc, e) => acc + e.iva, 0),
      total: inputData.reduce((acc, e) => acc + e.total, 0),
      fecha: "",
    };
    setList(optical.ventas);
    setSummaryData([data]);
  }, [optical]);

  return (
    <div
      style={{
        padding: "10px 0",
        display: "flex",
        flexDirection: "column",
        borderTop: "1px solid #d6d6d6",
        width: "100%",
        gap: 10,
      }}
    >
      <span className="dashboard-section-or-title">
        {optical.idOptica +
          " - " +
          optical.nombreOptica +
          " (" +
          optical.ventas.length +
          " de " +
          optical.totalVentas +
          ")"}
      </span>
      <>
        <DataTable
          columns={dashboardSalesTable}
          data={list}
          className="custom-datatable dashboard-custom-table non-interactive"
          noDataComponent="No hay datos de ventas disponibles para esta óptica."
        />
        {optical.ventas.length > 0 && (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 10,
            }}
          >
            <DataTable
              columns={dashboardSalesTable}
              data={summaryData}
              className="custom-datatable summary-row no-header-datatable"
            />
            <div
              className="opt-table-title"
              style={{
                marginBottom: 0,
                paddingBottom: 0,
                borderBottom: "none",
              }}
            >
              Totales óptica ({optical.totalVentas})
            </div>
            <DataTable
              columns={dashboardSalesTable}
              data={[
                {
                  base: optical.totalBase,
                  iva: optical.totalIVA,
                  total: optical.totalTotal,
                  fecha: "",
                },
              ]}
              className="custom-datatable summary-row no-header-datatable"
            />
            <ButtonIconH
              text={"Ver más (+20)"}
              small={true}
              onClick={() => {
                if (list.length < optical.totalVentas) {
                  onLoadMore(optical.idOptica, optical.ventas.length);
                }
              }}
            ></ButtonIconH>
          </div>
        )}
      </>
    </div>
  );
}
